/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_XY_LIVE", "542")
  

// 接口文档

  
    
export interface IAPI76846ResDataItemTargetBaseInfoObj {
  
  /** 表头字段live=直播，cpt=广告商单，cps=内容分发，endorsement=代言，offline=线下活动，commitmentTime=艺人投入时间 ,String */
  tableHeadList?: string[];
  
  /** 业务类别 */
  bizType?: string;
  
  /** IP类型 */
  ipType?: string;
  
  /** ip名称 */
  ipName?: string;
  
  /** ip编号 */
  ipNo?: string;
  
  /** 状态 */
  status?: string;
  
  /** 主召集人编号 */
  leaderNo?: string;
  
  /** 主召集人 */
  leader?: string;
  
  /** bp编号 */
  bpNo?: string;
  
  /** bp */
  bp?: string;
  
  /** 数据唯一编号 */
  baseNo?: string;
  
};
    
  
    
export interface IAPI76846ResDataItemLiveListItem {
  
  /** 序号 */
  id?: number;
  
  /** 业务编号 */
  bizNo?: string;
  
  /** 基础信息编号 */
  baseNo?: string;
  
  /** 平台 */
  platform?: string;
  
  /** 账号类型 */
  accountType?: string;
  
  /** 账号数量 */
  accountCount?: number;
  
  /** 单月直播场次数 */
  monthlySessionCount?: number;
  
  /** 单场直播小时数 */
  sessionDurationHours?: number;
  
  /** 单小时产出 */
  hourlyGmv?: number;
  
  /** 退货率 */
  returnRate?: number;
  
  /** 利润率(含坑位) */
  profitMargin?: number;
  
  /** 退货前GMV */
  preReturnGmv?: number;
  
  /** 退货后GMV */
  postReturnGmv?: number;
  
  /** 毛利 */
  grossProfit?: number;
  
  /** 预期运营成本占比 */
  expectedOpCostRatio?: number;
  
  /** 主播分成比例 */
  anchorSplitRatio?: number;
  
  /** 分成前毛利 */
  preSplitGrossProfit?: number;
  
  /** 主播分成后收益 */
  anchorPostSplitEarnings?: number;
  
  /** 遥望分成后收益 */
  yowantPostSplitEarnings?: number;
  
};
    
  
    
export interface IAPI76846ResDataItemCptListItem {
  
  /** 序号 */
  id?: number;
  
  /** 业务编号 */
  bizNo?: string;
  
  /** 基础信息编号 */
  baseNo?: string;
  
  /** 平台 */
  platform?: string;
  
  /** 账号类型 */
  accountType?: string;
  
  /** 账号数量 */
  accountCount?: number;
  
  /** 内容条数 */
  contentCount?: number;
  
  /** 广告条数 */
  adCount?: number;
  
  /** 广告单条价格 */
  adUnitPrice?: number;
  
  /** 总收入 */
  totalRevenue?: number;
  
  /** 投流成本 */
  streamingCost?: number;
  
  /** 拍摄制作剪辑成本 */
  productionCost?: number;
  
  /** 利润 */
  profit?: number;
  
  /** 分成比例 */
  revenueSharingRatio?: number;
  
  /** 主播分成后收益 */
  anchorPostSplitEarnings?: number;
  
  /** 遥望分成后收益 */
  yowantPostSplitEarnings?: number;
  
};
    
  
    
export interface IAPI76846ResDataItemCpsListItem {
  
  /** 主键 */
  id?: number;
  
  /** 业务编号 */
  bizNo?: string;
  
  /** 基础信息编号 */
  baseNo?: string;
  
  /** 平台 */
  platform?: string;
  
  /** 账号类型 */
  accountType?: string;
  
  /** 账号数量 */
  accountCount?: number;
  
  /** 单月短视频商品数 */
  shortVideoProductCount?: number;
  
  /** 短视频单品坑位费 */
  shortVideoProductSlotFee?: number;
  
  /** 短视频单品产出 */
  shortVideoProductOutput?: number;
  
  /** 短视频退前GMV */
  shortVideoGmvBeforeReturn?: number;
  
  /** 短视频退后GMV */
  shortVideoGmvAfterReturn?: number;
  
  /** 分成比例短视频单品退货率 */
  shortVideoProductReturnRate?: number;
  
  /** 短视频单品利润率 */
  shortVideoProductProfitRate?: number;
  
  /** 短视频毛利润 */
  shortVideoGrossProfit?: number;
  
  /** 投流成本 */
  advertisingCost?: number;
  
  /** 内容制作成本 */
  contentProductionCost?: number;
  
  /** 分成前收入 */
  shareBeforeIncome?: number;
  
  /** 分成比例 */
  shareRatio?: number;
  
  /** 分成后收益 */
  shareAfterProfit?: number;
  
  /** 分成后公司收益 */
  dividedCompanyIncome?: number;
  
};
    
  
    
export interface IAPI76846ResDataItemEndorsementListItem {
  
  /** 主键 */
  id?: number;
  
  /** 业务编号 */
  bizNo?: string;
  
  /** 基础信息编号 */
  baseNo?: string;
  
  /** 品牌代言数 */
  endorsementCount?: number;
  
  /** 代言费用 */
  endorsementFee?: number;
  
  /** 代言收入 */
  endorsementIncome?: number;
  
  /** 代言分成比例 */
  endorsementSplitRatio?: number;
  
  /** 分成后收益 */
  postSplitEarnings?: number;
  
  /** 妆发成本 */
  makeupHairCost?: number;
  
  /** 差旅成本 */
  travelCost?: number;
  
  /** 收益 */
  earnings?: number;
  
  /** 分成后公司收益 */
  postSplitCompanyEarnings?: number;
  
};
    
  
    
export interface IAPI76846ResDataItemOfflineListItem {
  
  /** 主键 */
  id?: number;
  
  /** 业务编号 */
  bizNo?: string;
  
  /** 基础信息编号 */
  baseNo?: string;
  
  /** 品牌商业活动数量 */
  brandActivityCount?: number;
  
  /** 活动费用 */
  activityCost?: number;
  
  /** 品牌商业活动收入 */
  brandActivityIncome?: number;
  
  /** 商业活动利润分成比例 */
  activityProfitSplitRatio?: number;
  
  /** 分成后收益 */
  postSplitEarnings?: number;
  
  /** 妆发成本 */
  makeupHairCost?: number;
  
  /** 差旅成本 */
  travelCost?: number;
  
  /** 收益 */
  earnings?: number;
  
  /** 分成后公司收益 */
  postSplitCompanyEarnings?: number;
  
};
    
  
    
export interface IAPI76846ResDataItemCommitmentTimeListItem {
  
  /** 主键 */
  id?: number;
  
  /** 业务编号 */
  bizNo?: string;
  
  /** 基础信息编号 */
  baseNo?: string;
  
  /** 短视频单次工作时长 */
  shortVideoSingleDuration?: number;
  
  /** 短视频每月拍摄次数 */
  shortVideoMonthlyShoots?: number;
  
  /** 大号直播单次工作时长 */
  largeLiveSingleDuration?: number;
  
  /** 大号每月直播场次 */
  largeLiveMonthlySessions?: number;
  
  /** 小号直播单次工作时长 */
  smallLiveSingleDuration?: number;
  
  /** 小号每月直播场次 */
  smallLiveMonthlySessions?: number;
  
  /** 艺人总时间投入 */
  totalArtistTimeInvestment?: number;
  
};
    
  
    
export interface IAPI76846ResDataItem {
  
  /** 分工 ,TargetBaseInfoResp */
  targetBaseInfo?: IAPI76846ResDataItemTargetBaseInfoObj;
  
  /** 月度直播目标 ,LiveTargetResp */
  liveList?: IAPI76846ResDataItemLiveListItem[];
  
  /** 月度广告商单目标（cpt） ,CPTTargetResp */
  cptList?: IAPI76846ResDataItemCptListItem[];
  
  /** 月度内容分发目标（cps） ,CPSTargetResp */
  cpsList?: IAPI76846ResDataItemCpsListItem[];
  
  /** 代言目标 ,EndorsementTargetResp */
  endorsementList?: IAPI76846ResDataItemEndorsementListItem[];
  
  /** 线下活动 ,OfflineTargetResp */
  offlineList?: IAPI76846ResDataItemOfflineListItem[];
  
  /** 艺人投入时间 ,CommitmentTimeTargetResp */
  commitmentTimeList?: IAPI76846ResDataItemCommitmentTimeListItem[];
  
};
    
  



export interface API76846Req {
  
    bizNo: string;
  
};



export type API76846Res = IAPI76846ResDataItem[];


// 接口函数 76846 查询excel目标

export interface IUseGetAPI76846Return {
  /** 查询excel目标: 接口请求状态 */
  isAPI76846Loading: boolean;
  /** 查询excel目标: 接口请求返回数据 */
  dataAPI76846: API76846Res;
  /**  查询excel目标: 接口数据请求方法 */
  fetchAPI76846Data: (inputs: API76846Req, config?: YWRequestConfig) => Promise<API76846Res>;
  /** 查询excel目标: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI76846 = ():IUseGetAPI76846Return => {
  let isMount = true;
  const [isAPI76846Loading, setIsAPI76846Loading] = useState(false);
  const [dataAPI76846, setDataAPI76846] = useState<API76846Res>({} as API76846Res);
  const requestUrl = `${basePath}/yoaichat-web/task/instance/query/monthly/target`;

  const fetchAPI76846Data = async (inputs: API76846Req, config?: YWRequestConfig): Promise<API76846Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API76846Req>) || {}) as API76846Req;
    
  
    if ( isMount ) {
      setIsAPI76846Loading(true);
    }

    try {
      
      const res: any = await Request.get<API76846Res>(`${basePath}/yoaichat-web/task/instance/query/monthly/target/${parseParams<API76846Req>(params)}`, {
        loginHost: loginPath,
        ...config
      });
      
      if (isMount) {
        setDataAPI76846(res || {} as API76846Res);
        setIsAPI76846Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI76846Loading(false);
      }
      return false as unknown as API76846Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI76846Loading,
    dataAPI76846,
    fetchAPI76846Data,
    requestUrl,
  }
}

